// * import third party
import { Box } from '@chakra-ui/react';

// * import local
import { useApp } from '@pages/UploadMappingV2/context/AppContext';
import { tableHeadListsProductSatuan } from './const';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';
import { useConfirmModal } from '@store/useConfirmModal';
import ModalConfirmTemplate from '@pages/UploadMappingV2/components/ui/ModalConfirmTemplate';
import TableAddProductSatuan from '../Table/TableAddProductSatuan';

export default function ModalAddProductSatuan() {
    const { set } = useConfirmModal();
    const {
        isOpenModalAddProductPiece,
        onCloseModalAddProductPiece,
        onOpenModalAddProductPiece,
        onOpenModalConfirmAddProductPiece,
    } = useApp();

    const {
        validatePiece,
        savePiece,
        saveDirectPiece,
        hasUnsavedChanges,
        isAdding,
        isEditing,
        saveUpdatedPiece,
        isDirectEditing,
        resetPiece,
    } = usePieceStore();

    const handleCancel = () => {
        if ((isEditing || isDirectEditing) && !isAdding) return handleCloseModal();

        if (hasUnsavedChanges()) {
            return set({
                isOpen: true,
                title: 'Batal menambahkan produk?',
                desc: 'Data yang telah dituliskan akan hilang, perlu melakukan pengisian ulang untuk menambahkan atau menghubungkan produk.',
                btnLabelYes: 'Ya, batal',
                btnLabelNo: 'Kembali',
                onSubmit: () => {
                    handleCloseModal();
                },
            });
        }

        handleCloseModal();
    };

    const handleSubmitPiece = () => {
        validatePiece();
        const { piece, errors } = usePieceStore.getState();
        if (Object.keys(errors).length) return;

        if (isDirectEditing) {
            saveDirectPiece();
            onOpenModalConfirmAddProductPiece();
        } else {
            if (isEditing && !isAdding) {
                saveUpdatedPiece(piece.localId, piece);
            } else {
                savePiece();
            }
        }

        handleCloseModal();
    };

    const handleCloseModal = () => {
        onCloseModalAddProductPiece();
        resetPiece();
    };

    return (
        <ModalConfirmTemplate
            isOpen={isOpenModalAddProductPiece}
            onClose={handleCancel}
            width="1000px"
            onSubmit={handleSubmitPiece}
            isCentered
        >
            <Box m={6} />
            <TableAddProductSatuan tableHeadLists={tableHeadListsProductSatuan} />
        </ModalConfirmTemplate>
    );
}
